const GroupConfigurationRole = [
    {key : "Medical Coder", value : "Medical Coder"},
    {key : "QA", value : "QA"}
]

export default GroupConfigurationRole